import React, { useState, useRef, useEffect } from "react";
import HotelIcon from "../assets/icons/hotel.png";
import LocationIcon from "../assets/icons/otherpins.png";
import TrainStationIcon from "../assets/icons/trainstation.png";
import AirportIcon from "../assets/icons/airport.png";
import BusStationIcon from "../assets/icons/busstation.png";

const Autocomplete = ({ onPlaceSelect, styles, onselect }) => {
  const [predictions, setPredictions] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null); // Ref for dropdown container

  useEffect(() => {
    if (!inputRef.current) {
      console.error("Input element is not available.");
      return;
    }

    if (typeof google === "undefined") {
      console.error("Google Maps API is not loaded.");
      return;
    }

    const autocompleteService =
      new window.google.maps.places.AutocompleteService();

    const handleInputChange = () => {
      const value = inputRef.current.value;
      if (!value) {
        setPredictions([]);
        return;
      }

      autocompleteService.getPlacePredictions(
        { input: value },
        (predictions) => {
          setPredictions(predictions || []);
        }
      );
    };

    const inputElement = inputRef.current;
    inputRef.current.addEventListener("input", handleInputChange);

    // Close dropdown when clicking outside of the component
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setPredictions([]); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      inputElement.removeEventListener("input", handleInputChange);
    };
  }, []);

  const handlePredictionClick = (place) => {
    // onselect(place);
    inputRef.current.value = place.description;
    setPredictions([]);
    fetchPlaceDetails(place.place_id);
  };

  const fetchPlaceDetails = (placeId) => {
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    service.getDetails({ placeId }, (placeDetails, status) => {
      if (
        status === window.google.maps.places.PlacesServiceStatus.OK &&
        placeDetails
      ) {
        const { lat, lng } = placeDetails.geometry.location;
        onPlaceSelect(lat(), lng());
        onselect(placeDetails);
      }
    });
  };

  const getIconForPlace = (place) => {
    if (place.types.includes("airport")) {
      return AirportIcon;
    } else if (place.types.includes("train_station")) {
      return TrainStationIcon;
    } else if (place.types.includes("bus_station")) {
      return BusStationIcon;
    } else if (place.types.includes("establishment")) {
      return HotelIcon;
    }
    return LocationIcon;
  };
  return (
    <div style={{ position: "relative" }}>
      <input
        ref={inputRef}
        type="text"
        placeholder="Search Points of Interest"
        style={{
          ...styles,
          width: styles?.width || "100%",
          padding: " 10px ",
          fontSize: "0.8rem",
          outline: "none",
          border: styles?.border || "none",
          borderRadius: "8px",
          height: "28px",
        }}
      />
      {predictions.length > 0 && (
        <div
          ref={dropdownRef} // Assign ref to the dropdown container
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            right: "0",
            backgroundColor: "white",
            // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            width: "100%",
            borderRadius: "8px",
            maxHeight: "280px",
            overflowY: "auto",
            zIndex: 1000,
          }}
          className="bxShadow"
        >
          {predictions.map((prediction) => (
            <div
              key={prediction.place_id}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid #ccc",
                fontSize: "0.8rem",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handlePredictionClick(prediction)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
            >
              <img
                src={getIconForPlace(prediction)}
                alt="icon"
                style={{ width: "15px", height: "15px", marginRight: "10px" }}
              />
              {prediction.description}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Autocomplete;
